import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, Validator, AbstractControl, ValidationErrors, Validators } from '@angular/forms';


@Directive({
  selector: '[appMinValue]',
  providers: [{provide: NG_VALIDATORS, useExisting: MinValueDirective, multi: true}]
})
export class MinValueDirective implements Validator {
  @Input('appMinValue') valueToCheck: string;

  validate(control: AbstractControl): ValidationErrors {
    let minCheck =  Validators.min(parseInt(this.valueToCheck))(control);
    return minCheck;
  }
  constructor() { }

}
